import React, {useEffect, useState} from "react";
import {communityService} from "../../../services/communityService/communityService";
import Loader from "../../../components/common/Loader";
import {useParams} from "react-router-dom";
import DiscussionsCommentList from "../../../components/DiscussionsCommentList";
import TextEditorContent from "../../../components/TextEditorContent";
import {toast} from "react-toastify";
import {AiFillHeart, AiOutlineHeart} from "react-icons/ai";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs/CustomBreadcrumbs";

const CommunityQuestionDetails = () => {
    const [communityQuestionDetails, setCommunityQuestionDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        getCommunityQuestionDetails();
    }, []);

    const getCommunityQuestionDetails = async () => {
        setIsLoading(true);
        try {
            const response = await communityService.getCommunityQuestionDetails(id);
            setCommunityQuestionDetails(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLike = async () => {
        try {
            const response = await communityService.likeCommunityDiscussion(id);
            setCommunityQuestionDetails(response.data);
            toast.success('Done!');
        } catch (err) {
            toast.error('Like discussion failed. Please try again.');
        }
    };

    return (
        <>
            <div className="container-fluid">
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <CustomBreadcrumbs
                            currentPageTitle={communityQuestionDetails?.title}
                            pages={[
                                {
                                    title: 'Questions for the Community',
                                    to: `/community/questions-for-the-community`
                                }
                            ]}
                        />
                        <div className="container m-4">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <h1>{communityQuestionDetails?.title}</h1>
                                    <TextEditorContent
                                        text={communityQuestionDetails?.description}
                                    />
                                    <div className="d-flex justify-content-end align-items-center" onClick={handleLike}>
                                        {communityQuestionDetails?.is_liked ? (
                                            <AiFillHeart
                                                fill="red"
                                                fontSize={30}
                                                style={{cursor: "pointer"}}
                                            />
                                        ) : (
                                            <AiOutlineHeart
                                                fontSize={30}
                                                style={{cursor: "pointer"}}
                                            />
                                        )}
                                        <span className="fs-5 fw-bold discussion-topic__likes-count">
                                            {communityQuestionDetails?.likes_count}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="master-class__comments">
                                        <DiscussionsCommentList
                                            path={`community/community-questions/${id}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default CommunityQuestionDetails;